import { LargeListSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { emailDesignsQueryOptions } from '@utils/queryOptions';
import EmailDesigns from '@Views/Emails/designs';

export const Route = createFileRoute('/emails/designs/')({
    component: EmailDesigns,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailDesignsQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: LargeListSkeleton,
});
